import React, {useEffect, useState} from "react";
import TextField from "../../../Utils/FormInputs/TextField";
import { ErrorMessage } from "../../../Utils/styledComponents";
import { CustomSelect } from "../../../Utils/FormInputs/SelectInput";
import Form from "react-bootstrap/Form";
import Label from "../../../Utils/FormInputs/Label";
import Col from "react-bootstrap/Col";
import InputGroup from "react-bootstrap/InputGroup";
import { ResizableTextarea } from "../../../Utils/FormInputs/Textarea";
import axios from "axios";
import config from "../../../Helpers/config.json";
import { errorMessages } from "../../../Helpers/ErrorMessages";
import { BlockNavigationComponent } from "../../../Utils/ReusableComponents/BlockNavigationComponent";
import {history} from "../../../Helpers/history";
import {AssetInfo, ViewDetailsComponent} from "./DetailsComponent";
import CustomDialog from "../../../Utils/Dialog/CustomDialog";


function DisposeFixedAsset({actions, openDialog, setOpenDialog, isSubmitted, setIsSubmitted,assetDetails}){
    const [state, setState] = useState({date:'', dispose_to: ''})
    const [submitted, setSubmitted] = useState(false);
    const [isBlocking, setIsBlocking] = useState(false)
    const [isBlockDialog, setIsBlockDialog] = useState(false)
    const [accounts, setAccounts] = useState([])
    const [receivingAccount, setReceivingAccount] = useState({value:'', label:''})
    const [reason, setReason] = useState({value:'', label:''})
    const [openDetails, setOpenDetails] = useState(false)
    const [totalAmount, setTotalAmount] = useState({received_amount:'', converted_amount:0})


    useEffect(() => {
        (async () => {
            try {
                const res = await axios.get(`${config.epharmUrl}/accounting/chart/cash_ledgers`)
                let _data = res.data
                let dt = _data ?? [];
                let credits = dt.map(i => ({label: i.head_name, value: i.id}))
                setAccounts(credits)
            } catch (e) {
                // errorMessages(e, null, actions)
            }
        })();
    }, [])

    const handleChangeState = (event) =>{
        const {name, value} = event.target
        setState({...state,[name]:value})
        setIsBlocking(true)
    }

    const handleChangeReceivingAcount = (value) =>{
        setReceivingAccount(value)
        setIsBlocking(true)
    }

    const handleChangeReason = (value) =>{
        setReason(value)
        setIsBlocking(true)
    }

    const handleCloseDialog = () =>{
        if(isBlocking){
            setIsBlockDialog(true)
        }else{
            setOpenDialog(false)
            setIsBlockDialog(false)
            setIsBlocking(false)
        }
    }

    const handleChangeReceivedAmount = (event) =>{
        const {value} = event.target
    
        setTotalAmount({...totalAmount,received_amount:value})
        setIsBlocking(true)
    }

    const handleSubmit = (e) => {
        e.preventDefault()
        const data = {
            asset_id:assetDetails?.state?.id,
            disposal_date:state.date,
            receiving_account : receivingAccount?.value,
            dispose_to: state.dispose_to,
            reason:reason?.value,
            amount:totalAmount?.received_amount,
            converted_amount:totalAmount?.converted_amount
        }
        setSubmitted(true);
        if (state.date && receivingAccount.value && state.dispose_to && reason.value && totalAmount.received_amount) {
            setIsSubmitted('pending')
            axios.post(`${config.epharmUrl}/accounting/fixed_asset/sale/add`, data).then(() => {
                actions.snackbarActions.successSnackbar('Asset disposed off successfully')
                setIsSubmitted('resolved')
                handleResetForm()
            }).catch(err => {
                errorMessages(err, null, actions);
                setIsSubmitted('rejected')
            })
        }
    }

    const handleResetForm = () =>{
        setOpenDialog(false)
        setIsBlockDialog(false)
        setIsBlocking(false)
        setReceivingAccount('')
        setReason('')
        setState({date:'', dispose_to: ''})
        setTotalAmount({received_amount: 0, converted_amount: 0})
    }

    const isPending = isSubmitted === 'pending'

    return (
        <div>
            <BlockNavigationComponent
                when={isBlocking}
                shouldBlockNavigation={() => {
                    return isBlocking;
                }}
                navigate={path => history.push(path)}
                dialogClose={isBlockDialog}
                setIsBlockDialog={setIsBlockDialog}
                clearForm={handleResetForm}
            />
            <CustomDialog open={openDialog} handleClose={handleCloseDialog} title={`Dispose ${assetDetails?.state?.asset_name}`} maxWidth='lg'>
                <ViewDetailsComponent title={assetDetails?.state?.asset_name} open={openDetails} handleOpen={()=>{
                    setOpenDetails(!openDetails)
                }}>
                    <AssetInfo {...assetDetails}/>
                </ViewDetailsComponent>
                <form onSubmit={handleSubmit} autoComplete='off'>
                    <div className="row">
                        <div className="col-lg-6">
                            <Form.Group as={Col}>
                                <Label name="Date" type htmlFor='dispose_date'/>
                                <TextField type='date' value={state.date} name='date' id="dispose_date" submitted={submitted} onChange={handleChangeState}/>
                                {submitted && !state.date ? <ErrorMessage>Date is required</ErrorMessage>: null}
                            </Form.Group>
                            <Form.Group as={Col}>
                                <Label name="Dispose to" type htmlFor='dispose_to'/>
                                <ResizableTextarea rows={1} value={state.dispose_to} name='dispose_to' id='dispose_to' submitted={submitted} onChange={handleChangeState}/>
                                {submitted && !state.dispose_to ? <ErrorMessage>Dispose to  is required</ErrorMessage>: null}
                            </Form.Group>
                            <Form.Group as={Col}>
                                <Label name="Reason" type/>
                                <CustomSelect value={reason} options={[{value:'Sale', label:'Sale'},{value:'Donation', label:'Donation'}]}
                                              onChange={handleChangeReason} id='dispose_reason'/>

                                {(submitted && !reason) ?
                                    <ErrorMessage>Reason  is required</ErrorMessage> : null}
                            </Form.Group>
                            <Form.Group as={Col}>

                                <Label name="Receiving Account" type/>
                                <CustomSelect value={receivingAccount} options={accounts}
                                              onChange={handleChangeReceivingAcount} id='receiving_account'/>

                                {(submitted && !receivingAccount) ?
                                    <ErrorMessage>Receiving account  is required</ErrorMessage> : null}
                            </Form.Group>

                        </div>
                        <div className="col-lg-6">
                            <Form.Group as={Col}>
                                <Label name={`Amount Received(UGX)`} />
                                <InputGroup className="">
                                    <InputGroup.Text style={{borderRadius: '0.7rem 0 0 0.7rem'}}
                                                     id="basic-addon1">UGX</InputGroup.Text>
                                    <TextField submitted={submitted} type="number" value={totalAmount.received_amount}
                                               onChange={handleChangeReceivedAmount} name='received_amount' id='received_amount'/>
                                    {(submitted && !totalAmount.received_amount) ?
                                        <ErrorMessage>Received amount  is required</ErrorMessage> : null}
                                </InputGroup>
                            </Form.Group>
                        </div>
                    </div>
                    <button type='submit' disabled={isPending}
                            className='btn btn-sm pharmacy-btn'>{isPending ? 'Submitting...' : 'Submit'}</button>
                </form>
            </CustomDialog>
        </div>

    )
}

export {DisposeFixedAsset}